<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.jushuitanInventoryOut')"
    resource="jushuitan_inventory_outs"
    :batch-actions="batchActions"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/jushuitan_inventory_outs.js';
import { filterColumnsExtend as customerFilterColumnsExtend } from '../admin_grapes/customers.js';
import { abilityService } from 'beans-admin-plugin';
import { INVENTORY_OUT_STATUS } from '@/constants';
import _ from 'lodash';

@Component
export default class JushuitanInventoryOuts extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      {
        key: 'status_in',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            multiple: true,
            options: _.map(INVENTORY_OUT_STATUS, (key, value) => ({ label: key, value }))
          }
        }
      },
      'so_id_eq',
      { key: 'o_id_eq', renderCell: { component: 'input' } },
      'io_id_eq',
      'customer_id_eq',
      abilityService.can('users.read_options') && 'customer_user_id_eq',
      'customer_customer_source_id_eq',
      'customer_customer_level_id_eq',
      'customer_customer_tags_id_eq',
      {
        ...customerFilterColumnsExtend(['customer_business_models_id_eq'])[0],
        prop: 'customer_customer_business_models_id_eq',
      },
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'io_id',
      'kind',
      {
        key: 'status',
        renderCell(h, { props: { value } }) {
          return <span>{INVENTORY_OUT_STATUS[value]}</span>
        }
      },
      'order',
      'shop',
      'order_type',
      'pay_amount',
      'paid_amount',
      type === 'show' && 'freight',
      type === 'show' && 'free_amount',
      type === 'show' && 'pay_date',
      'io_date',
      type === 'show' && {
        key: 'items',
        renderCell: (h, { props: { value } }) => {
          return <bean-table height={null} value={value} columns={[{
            prop: 'name',
            label: '商品名称',
          }, {
            prop: 'pic',
            label: '图片',
            renderCell(h, { props: { value } }) {
              return <el-image style="width: 100px; height: 100px" src={value} fit="contain" preview-src-list={[value]}  />
            }
          }, {
            prop: 'qty',
            label: '数量',
          }, {
            prop: 'properties_value',
            label: '属性',
          }]} />
        },
      },
      'logistics_company',
      'l_id',
      type === 'show' && 'modified',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      type === 'new' && {
        prop: 'o_id',
        label: this.$t('jushuitanOrder.oId'),
        renderCell: {
          component: 'input',
          props: {
            placeholder: '请输入聚水潭订单ID'
          }
        }
      }
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'jushuitan_inventory_outs.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'jushuitan_inventory_outs.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }


  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$autoLoading(this.$request.get(`/${resource}/export`, { ...this.$route.query }));
      } else {
        await this.$autoLoading(this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) }));
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>{this.$t('export')}</el-button>,
    ]
  }
}

export const route = [
  {
    path: '/jushuitan_inventory_outs',
    name: 'jushuitan_inventory_outs.index',
    component: JushuitanInventoryOuts,
    props: {
      type: 'index',
    }
  },
  {
    path: '/jushuitan_inventory_outs/new',
    name: 'jushuitan_inventory_outs.new',
    component: JushuitanInventoryOuts,
    props: {
      type: 'new',
    }
  },
  {
    path: '/jushuitan_inventory_outs/:id',
    name: 'jushuitan_inventory_outs.show',
    component: JushuitanInventoryOuts,
    props: {
      type: 'show',
    }
  },
  {
    path: '/jushuitan_inventory_outs/:id/edit',
    name: 'jushuitan_inventory_outs.edit',
    component: JushuitanInventoryOuts,
    props: {
      type: 'edit'
    }
  }
]
</script>
